import {
	SidebarGroup,
	SidebarGroupContent,
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
} from "@/components/ui/sidebar"
import { Link, useLocation } from "react-router-dom"
import type { IRoute } from "@/app/routes/route"
import { cn } from "@/lib/utils"
export function NavMain({
	items,
}: {
	items: IRoute[]
}) {

	const { pathname } = useLocation();

	return (
		<SidebarGroup>
			<SidebarGroupContent className="flex flex-col gap-2">
				<SidebarMenu className="mt-10">
					{items.filter((item) => item.type != 'index' && item.path).map((item) => (
						<Link to={item.path as string} key={item.path}>
							<SidebarMenuItem key={item.name}>
								<SidebarMenuButton tooltip={item.name} className={cn('cursor-pointer py-5', pathname === item.path && 'bg-primary text-primary-foreground')}>
									{item.icon && <item.icon />}
									<span>{item.name}</span>
								</SidebarMenuButton>
							</SidebarMenuItem>
						</Link>
					))}
				</SidebarMenu>
			</SidebarGroupContent>
		</SidebarGroup>
	)
}
